import ApiService, { ApiArguments } from '@/api/api_service';
import ApiBase from '@/api/base';
import { CallResultTypeApi, GetCallResultTypeSummaries200Response } from '@/api/openapi';

export class CallResultTypeApiService extends ApiService {
  api = new CallResultTypeApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getCallResultTypeSummaries(
    {
      options,
      errorHandlers,
    }: ApiArguments<undefined> = {},
  ) {
    return this.checkResponse<GetCallResultTypeSummaries200Response>(
      this.api.getCallResultTypeSummaries(options),
      errorHandlers,
    );
  }
}

export default {
  getCallResultTypes () {
    return ApiBase.get(`/user/call_result_types`);
  },
  createCallResultType (args) {
    return ApiBase.post(`/user/call_result_types`, args);
  },
  deleteCallResultType (args) {
    return ApiBase.delete(`/user/call_result_types/${args.id}`, args);
  },
  // 単体更新
  updateCallResultType (args) {
    return ApiBase.put(`/user/call_result_types/${args.id}`, args);
  },
  // 一括更新
  updateCallResultTypes (args) {
    return ApiBase.put(`/user/call_result_types`, args);
  },
};
